export enum MoveType {
  Eat, MoveAnimal, RevealMosquito, DiscardTokenFromBoard, ChooseMosquitoEffect, SelectAnimal, SelectMosquitoToken, MoveMosquitoToken, SelectOpponentAnimal, SkipTurn, ChangeActivePlayer, DiscardTokenFromPlayerBoard
}